import { render, staticRenderFns } from "./MopSortSelector.vue?vue&type=template&id=3e52937c&scoped=true&"
import script from "./MopSortSelector.vue?vue&type=script&lang=js&"
export * from "./MopSortSelector.vue?vue&type=script&lang=js&"
import style0 from "./MopSortSelector.vue?vue&type=style&index=0&id=3e52937c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e52937c",
  null
  
)

export default component.exports